<template>
  <div class="distributor-search__skeleton__list__item">
    <div
      class="distributor-search__skeleton__list__item__text"
    >
      <Skeleton
        class="distributor-search__skeleton__list__item__text__top"
      />
      <Skeleton
        class="distributor-search__skeleton__list__item__text__bottom"
      />
      <Skeleton
        class="distributor-search__skeleton__list__item__text__bottom"
      />
    </div>
    <div class="distributor-search__skeleton__list__item__icons">
      <CommunicationEmail
        class="icon email"
        :title="$tv('emailIconTooltip', 'distributorSearch')"
      />
      <SocialPublic
        class="icon globe"
        :title="$tv('globeIconTooltip', 'distributorSearch')"
      />
    </div>
  </div>
</template>

<script>
import {Skeleton} from '@progress/kendo-vue-indicators'
import CommunicationEmail from '~/assets/icons/communication_email.svg?component'
import SocialPublic from '~/assets/icons/social_public.svg?component'

export default {
  components: {
    Skeleton,
    CommunicationEmail,
    SocialPublic
  }
}
</script>

<style lang="scss">
.distributor-search__skeleton__list__item {
  padding: .75rem 0;
  display: flex;
  flex-direction: row;

  &__text {
    width: 80%;
    margin-left: .75rem;
    float: left;

    &__top {
      margin-bottom: 1.25rem;
      background-color: $color__primary;
      width: 50%;
      height: 1rem;
      vertical-align: top;
    }

    &__bottom {
      margin-bottom: .5rem;
      width: 70%;
      height: .75rem;
      vertical-align: top;

      &:last-child {
        width: 30%;
        margin: 0;
      }
    }
  }

  &__icons {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon {
      filter: blur(.125rem);
      width: 1.5rem;
      height: 1.5rem;

      &.email {
        fill: $color__primary;
        margin-bottom: .75rem;
      }

      &.globe {
        margin-top: .75rem;
        fill: $color__default;
      }
    }
  }
}
</style>
